declare var $: any; //Need this to use JQuery
import Swal from 'sweetalert2'
import * as moment from'moment';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AvantoRoutingService } from 'src/app/services/avanto-routing.service';
import { AvantoUserAuthService } from 'src/app/services/avanto-user-auth.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { AvantoCognitoService } from 'src/app/services/avanto-cognito.service';
import { Subscription } from 'rxjs';
import { AvantoCustomerService } from 'src/app/services/avanto-customer-info.service';
import { CustomerLastOrders } from 'src/app/avantoeats-util/models/customer/CustomerLastOrders';
import { AvantoAlert } from 'src/app/util/Alerts';

@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrls: ['./customer-dashboard.component.scss']
})
export class CustomerDashboardComponent implements OnInit, OnDestroy {

  constructor(private avantoSession: AvantoSessionService, private avantoRoute: AvantoRoutingService, private auth: AvantoUserAuthService,
    private cognito: AvantoCognitoService, private customerService: AvantoCustomerService) { }

  oldPassword: string;
  newPassword: string;
  confirmPassword: string;

  customerName: string;
  customerUsername: string;
  customerPhone: string;
  customerMail: string;
  isPhoneVerified: boolean;
  isMailVerified: boolean;

  newCustomerName: string;

  modalContent: string
  showEmailVerificationInput: boolean;

  emailVerificationCode: string;

  sessionSubscription: Subscription = new Subscription();
  customerSubstcription: Subscription = new Subscription();

  isOneRestaurantMode: boolean
  oneRestModeRestId: string;

  customerLastOrders: CustomerLastOrders[];

  //TODO: MAKE THIS GLOBAL
  showOverlay: boolean;

  ngOnInit() {
    this.showOverlay = true;
    this.showEmailVerificationInput = false;
    this.isOneRestaurantMode = false;
    this.emailVerificationCode = "";
    this.modalContent = "";

    //Getting the customer information from the cognito token
    this.auth.getCustomerInfo()
      .then(idTokenInfo => {
        this.customerName = idTokenInfo.name;
        this.newCustomerName = this.customerName;
        this.customerPhone = idTokenInfo.phone;
        this.customerMail = idTokenInfo.email;
        this.customerUsername = idTokenInfo.id
        this.isMailVerified = idTokenInfo.isMailVerified;
        this.isPhoneVerified = idTokenInfo.isPhoneVerified;
        this.customerLastOrders = [];

        this.customerService.getCustomer(idTokenInfo.id, true)
          .then((response) => {
            this.customerLastOrders = response.lastOrders;
            this.customerLastOrders.sort((a,b)=>{ return moment(b.orderDate).diff(moment(a.orderDate)) })
          })
          .catch((err) => {
            console.error(err)
          })
          .finally(() => {
            this.showOverlay = false;
          })

      }).catch(error => {
        console.log("COULD NOT GET USER SESSION. REDIRECTING TO LOGIN PAGE!", error)
        this.avantoRoute.goToCustomerLoginPage();
        this.showOverlay = false;
      })

    //Observing the session
    this.sessionSubscription = this.avantoSession.sessionSubject.subscribe((session) => {
      if (session != null) {
        this.isOneRestaurantMode = session.isOneRestaurantMode;
        if (this.isOneRestaurantMode) {
          this.oneRestModeRestId = session.restaurantInformation.restaurantId;
        } else {
          this.oneRestModeRestId = "";
        }
      }
    });
  }

  ngOnDestroy() {
    this.sessionSubscription.unsubscribe();
    this.customerSubstcription.unsubscribe
  }

  signout() {
    this.cognito.logout().then(() => {
      const restaurantSplit = this.oneRestModeRestId.split(".");
      if (this.isOneRestaurantMode) {
        this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantSplit[0], restaurantSplit[1])
      } else {
        this.avantoRoute.goToInitialPage()
      }
    })
  }

  openModal(content) {
    this.modalContent = content;
    $("#receiptModal").modal();
  }

  reOrderClicked(clientId, cart) {
    if (!this.avantoSession.isCartEmpty()) {
      Swal.fire({
        title: 'You already have items in your cart',
        text: "Re-ordering will replace the items in your cart by the ones in the previous order. Are you sure you want to do that?",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          this.reOrder(clientId, cart)
        }
      })
    } else {
      this.reOrder(clientId, cart)
    }
  }

  test() {
    this.cognito.logout();
  }


  private reOrder(clientId, cart) {
    this.avantoSession.reOrderCart(clientId, cart)
      .then(() => { AvantoAlert.toast("success", "Your cart has been updated!") })
      .catch(err => { Swal.fire("Could not make the re-order", err, "error") })
  }

  changePassword() {
    if (this.newPassword != this.confirmPassword) {
      Swal.fire({ type: 'error', title: "The passwords do not match!" })
      return;
    }

    this.cognito.changePassword(this.oldPassword, this.newPassword)
      .then(success => {
        Swal.fire({ type: 'success', title: "Your password has been updated" })
      })
      .catch(error => {
        console.error(error)
        Swal.fire({ type: 'error', title: "Could not change the password", text: "Are you sure the information provided is correct?" })
      })
  }

  changeCustomerInfo() {
    this.showOverlay = true;
    this.cognito.changeCustomerInfo(this.newCustomerName)
      .then(() => {
        Swal.fire({ type: 'success', title: "Your personal information has been updated" })
        this.customerName = this.newCustomerName;
      })
      .catch(() => {
        Swal.fire({ type: 'error', title: "Your personal information cold not be updated" })
        this.newCustomerName = this.customerName;
      })
      .finally(() => {
        this.showOverlay = false;
      })
  }

  /** Sends an e-mail to the user containing the verification code  */
  verifyEmail() {
    //TODO: SEND THIS TO THE COGNITO SERVICE!
    this.showOverlay = true;
    this.cognito.verifyMail()
      .then(() => {
        AvantoAlert.toast("success", "A verification code has been sent to your e-mail!")
        this.showEmailVerificationInput = true;
      })
      .catch(() => {
        Swal.fire({ type: 'error', title: "Could not send a verification code to your e-mail" })
      })
      .finally(() => {
        this.showOverlay = false;
      })
  }

  confirmEmailVerification() {
    this.cognito.confirmEmailVerificationCode(this.customerUsername, this.emailVerificationCode)
      .then((response) => {
        Swal.fire({ type: 'success', title: "Your e-mail has been verified" })
        this.isMailVerified = true;
        this.showEmailVerificationInput = false;
      })
      .catch((err) => {
        console.error(err)
        Swal.fire({ type: 'error', title: 'Could not verify your e-mail. Try again later.' })
      });
  }
}